import { ColumnItemElement, DreamBlock } from '@typedream/core';
import {
  findNode,
  focusEditor,
  getNode,
  getParentNode,
  moveNodes,
  withoutNormalizing,
  wrapNodes,
} from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../types';
import { DragItem, DropDirection } from './types';

export const dropItemOnElement = (
  editor: DreamEditor,
  at: Path,
  item: DragItem,
  direction: DropDirection = 'bottom',
) => {
  const dragEntry = findNode(editor, {
    at: [],
    match: (node) => node.id === item.id,
  });
  if (!dragEntry) return;

  const [, dragPath] = dragEntry;

  let dropPath = at;
  if (!dropPath) return;

  if (['top', 'bottom'].includes(direction)) {
    if (direction === 'bottom') {
      dropPath = Path.next(dropPath);
    }

    if (
      Path.isSibling(dragPath, dropPath)
      && Path.isBefore(dragPath, dropPath)
    ) {
      dropPath = Path.previous(dropPath);
    }

    moveNodes(editor, {
      at: dragPath,
      to: dropPath,
    });

    focusEditor(editor);

    return;
  }

  if (['left', 'right'].includes(direction)) {
    const targetElement = getNode<DreamBlock>(editor, dropPath);
    const targetParentEntry = getParentNode(editor, dropPath);

    if (targetParentEntry?.[0].type === 'column_item') {
      const node = targetParentEntry[0] as ColumnItemElement;
      [, dropPath] = targetParentEntry;

      if (direction === 'right') {
        dropPath = Path.next(dropPath);
      }

      withoutNormalizing(editor, () => {
        wrapNodes(
          editor,
          {
            type: 'column_item',
            width: node.width,
            children: [],
          },
          { at: dragPath },
        );
        moveNodes(editor, {
          at: dragPath,
          to: dropPath,
        });
      });

      focusEditor(editor);

      return;
    }

    if (targetElement?.type === 'column') {
      withoutNormalizing(editor, () => {
        wrapNodes(
          editor,
          {
            type: 'column_item',
            width:
              direction === 'left'
                ? targetElement.children[0].width
                : targetElement.children[targetElement.children.length - 1]
                  .width,
            children: [],
          },
          { at: dragPath },
        );
        moveNodes(editor, {
          at: dragPath,
          to: [
            ...dropPath,
            direction === 'left' ? 0 : targetElement.children.length,
          ],
        });
      });
      return;
    }

    withoutNormalizing(editor, () => {
      wrapNodes(editor, { type: 'column', children: [] }, { at: dropPath });
      moveNodes(editor, {
        at: dragPath,
        to: [...dropPath, direction === 'left' ? 0 : 1],
      });
    });

    focusEditor(editor);
  }
};
